import { queryOptions } from "@tanstack/react-query";
import { FormStep } from "./InteractiveForm";
import { backendApi } from "../../api";

export function freeFormQuery(freeForm: string) {
  return queryOptions({
    queryKey: ["freeForm", freeForm],
    queryFn: async ({ signal }) => {
      const response = await backendApi<{ algorithm: FormStep; title: string }>(
        {
          url: `/algorithms/${freeForm}`,
          signal,
        }
      );
      return response.data;
    },
    staleTime: 1000 * 60, // Expire after 1 minute
  });
}

export function publicAlgorithmQuery(algorithmId: string) {
  return queryOptions({
    queryKey: ["publicAlgorithm", algorithmId],
    queryFn: async ({ signal }) => {
      const response = await backendApi<{ algorithm: FormStep; title: string }>(
        {
          url: `/algorithms/public/${algorithmId}`,
          signal,
        }
      );
      return response.data;
    },
    staleTime: 1000 * 60, // Expire after 1 minute
  });
}
